
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Footer from '../components/Footer';
import Header from '../components/Header';

const SocialFeeds = () => {
  useEffect(() => {
    document.body.classList.add('elevate-home', 'inner-page');

    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });

    const previousTitle = document.title;

    const descriptionElement = document.head.querySelector(
      'meta[name="description"]'
    );

    const previousDescription = descriptionElement
      ? descriptionElement.getAttribute('content') || ''
      : null;

    document.title = 'Services - Elevate Realty';

    if (descriptionElement) {
      descriptionElement.setAttribute(
        'content',
        'Elevate Realty services - off-plan advisory, portfolio management, private client services, Golden Visa guidance and mortgage support in Dubai.'
      );
    }

    if (window.AOS) {
      window.AOS.init({
        duration: 800,
        once: true,
        offset: 80
      });

      if (window.AOS.refreshHard) {
        window.AOS.refreshHard();
      }
    }

    return () => {
      document.body.classList.remove('elevate-home', 'inner-page');

      document.title = previousTitle;

      if (descriptionElement && previousDescription !== null) {
        descriptionElement.setAttribute(
          'content',
          previousDescription
        );
      }
    };
  }, []);

  useEffect(() => {
    const scriptId = 'elfsight-platform-script';

    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      // Keep the script loaded for React route navigation.
      // Do not remove Elfsight's global script here.
    };
  }, []);

  return (
    <>
      <Header />

      <main className="inner-main" id="top">
        <section className="inner-hero services-hero">
          <div
            className="inner-hero__content"
            data-aos="fade-up"
          >
            <p className="eyebrow">Social Feeds</p>

            <h1>
              Discover What’s Happening Across Our <em>Social Channels.</em>
            </h1>

            <p>
              Explore our latest updates, stories, and highlights from across our social media channels. Stay connected and be part of our journey.
            </p>

            <div className="inner-kicker-row">
              <Link className="primary-link" to="/contact-us">
                Contact with Us
              </Link>

           
            </div>
          </div>
        </section>

        <section
          className="inner-section"
          style={{
            width: '100%',
            minHeight: '400px'
          }}
        >
          <div
            className="elfsight-app-307a1989-d130-4d93-9a62-7959fd949502"
            data-elfsight-app-lazy
          />
        </section>
      </main>

      <Footer />

      <a
        className="advisor-button"
        href="https://api.whatsapp.com/send?phone=971507135432&text=Hi"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Speak with an advisor on WhatsApp"
      >
        <svg
          className="advisor-button__icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M21 11.5a8.5 8.5 0 0 1-12.7 7.4L3 20l1.2-5A8.5 8.5 0 1 1 21 11.5Z" />
        </svg>

        <span>Speak with an advisor</span>
      </a>
    </>
  );
};

export default SocialFeeds;
